module.exports = __webpack_public_path__ + "media/images/unemployment-graph-2023-7a39ecee38db3c7b7d0826972db0a44e.svg";